<template>
  <div class="navbar-area">
    <nav class="navbar navbar-area-1 navbar-area navbar-expand-lg">
      <div class="container nav-container">
        <div class="logo">
          <a href=""><img src="../assets/logo.png" alt="img" /></a>
        </div>
        <div class="name">技术组</div>
        <div class="login" v-if="!token || token === ''">
          <router-link :to="{ name: 'login' }">登录 </router-link>
        </div>
        <div v-else class="login" @click="loginOut">欢迎您,{{ username }}</div>
      </div>
    </nav>
    <!-- 确认退出 -->
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex'
import Cookies from 'js-cookie'
import { getToken, setToken, removeToken } from '@/utils/auth'

export default {
  data() {
    return {
      // username: '',
      showLoginOut: false
    }
  },
  props: {},
  computed: {
    ...mapState(['token', 'username'])
  },
  mounted() {
    console.log(111)
  },
  methods: {
    ...mapMutations(['SET_USERNAME', 'SET_PASSWORD']),
    loginOut() {
      this.$confirm('确定要退出该账号?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // removeToken()
          Cookies.remove('token')
          // Cookies.remove('username')
          // Cookies.remove('password')
          this.$message({
            type: 'success',
            message: '退出成功!'
          })
          setTimeout(() => {
            this.$router.go(0)
          }, 1000)

          // this.$message({
          //   type: 'success',
          //   message: '退出成功!'
          // })
          // console.log(this.$store.dispatch)
          // this.$store.dispatch('LogOut').then(() => {
          //   location.href = '/layout'
          // })
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消退出'
          // })
        })
    }
  },
  mounted() {
    // this.username = Cookies.get('username')
  }
}
</script>

<style lang="less" scoped>
.name {
  padding-left: 30px;
  flex: 1;
  font-size: 28px;
  color: white;
}
.login {
  font-size: 18px;
  color: white;
}
a {
  color: white;
}
</style>
